import { render, staticRenderFns } from "./user-items-secondary.vue?vue&type=template&id=e3d34c52&scoped=true"
import script from "./user-items-secondary.vue?vue&type=script&lang=js"
export * from "./user-items-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d34c52",
  null
  
)

export default component.exports